exports.ByName = {
  Country: { Id: 1, Key: 'countryId' },
  Region: { Id: 2, Key: 'regionId' }
};

exports.ById = {
  1: { Id: 1, Key: 'countryId' },
  2: { Id: 2, Key: 'regionId' }
};
